import { render, staticRenderFns } from "./TravelCreate.vue?vue&type=template&id=0805feb9&"
import script from "./TravelCreate.vue?vue&type=script&lang=js&"
export * from "./TravelCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports